//change gift field names
function initFields(gsCheckEl) {

  if( gsCheckEl ) {
    var giftPrefix = 'items[0]',
        giftNoteEl = document.querySelector('.gsMessageContainer');

    if( giftNoteEl ) {
      var infoEl = document.querySelector('#ZlistWishlist'),
          fieldEls = giftNoteEl.querySelectorAll('.gs__product-element');

      gsCheckEl.name = giftPrefix + 'id';

      if( infoEl ) {
        var itemNoteEl = document.createElement('input');

        itemNoteEl.name = giftPrefix + 'properties[Item]';
        itemNoteEl.id = 'item-note';
        itemNoteEl.className = "gs__product-element";
        itemNoteEl.type = "hidden";
        itemNoteEl.disabled = true;
        
        if( infoEl.dataset.title ) {
          itemNoteEl.dataset.init = infoEl.dataset.title.replace('"', '');
        }
        
        giftNoteEl.insertBefore(itemNoteEl, giftNoteEl.children[0]);
      }

      if( fieldEls ) {
        var i = 0,
            len = fieldEls.length;
        for (i; i < len; i++) {
          fieldEls[i].name = giftPrefix + fieldEls[i].name;
        }
      }
    }
  }
}

//update field attributes
function updateFields(attrName,attrValue,isRequired) {
  var giftNoteEl = document.querySelector('.gsMessageContainer'),
      fieldEls = giftNoteEl? giftNoteEl.querySelectorAll('.gs__product-element') : '';

  if( fieldEls ) {
    var i = 0,
        len = fieldEls.length;

    for (i; i < len; i++) {
      if( isRequired ) {
        if( !fieldEls[i].value ) {
          fieldEls[i][attrName] = attrValue;
        }
      }
      else {
        fieldEls[i][attrName] = attrValue;
      }

    }
  }
}

//enable-disable fields
function toggleFields(isChecked) {
  var isDisabled = isChecked? false : true,
      giftNoteEl = document.querySelector('.gsMessageContainer');

  if( giftNoteEl ) {
    updateFields('disabled', isDisabled, false);
    
    if( !isDisabled ) {
      giftNoteEl.classList.remove('gs__hidden-option');
    }
    else {
      giftNoteEl.classList.add('gs__hidden-option');
    }
  }
}


//gift options
document.addEventListener('giftship.loaded', function() {

  //is gift?
  var gsCheckEl = document.querySelector('.gs__oneclick-variant');

  if( gsCheckEl && gsCheckEl.value == '41603155034278' ) {
    //init
    initFields(gsCheckEl);
    toggleFields(false);

    //toggle checkbox
    gsCheckEl.addEventListener('change', function() {
      toggleFields(this.checked);
    });

    //event on form submit
    var addBtnEl = document.querySelector('.add-to-cart');
    addBtnEl.addEventListener('click', function() {
      if( gsCheckEl.checked ) {

        //update Item Note with Product Title
        var itemNoteEl = document.querySelector('#item-note');

        if( itemNoteEl ) {
          var titleText = '',
              variantEl = document.querySelector('.variant-wrapper');

          titleText = itemNoteEl.dataset.init;

          if( titleText && variantEl ) {
            var variantText = '',
                selectEls = variantEl.querySelectorAll('input[type="radio"]:checked');
            if( selectEls ) {
              var i = 0,
                  len = selectEls.length;
              for (i; i < len; i++) {
                variantText += selectEls[i].name + ': ' + selectEls[i].value + ', ';
              }
            }
          }

          //update Item Title
          if( titleText ) {
            if( variantText ) {
              titleText = titleText + ' (' + variantText.slice(0, -2) + ') ';
            }

            itemNoteEl.value = titleText.replace('"', '');
          }
          else {
            itemNoteEl.disabled = true;
          }
        }

        //disable any empty fields
        updateFields('disabled', true, true);
      }

      //reset checkbox
      $(document).ajaxStop(function() {
        gsCheckEl.checked = false;
        updateFields('value', '', false);
        toggleFields(false);
      });
    });
  }
});